module.exports = __webpack_public_path__ + "static/media/camping-tree.f9432462.png";